import { TDownloadLinks } from "@/utils/getDownloadLinks";
import { useFeature } from "@growthbook/growthbook-react";

export function useDownloadLinks(): TDownloadLinks | null {
  const feature = useFeature("restructuring-split");

  if (!feature.on) return null;

  try {
    return JSON.parse(feature.value) as TDownloadLinks;
  } catch {
    return null;
  }
}
